module.exports = __webpack_public_path__ + "static/media/logo-circle-color.eb969bbf.svg";